<template>
    <div class="turn-page clearfix" style="padding: 8px;">
        <div class="pull-right pages">
            <span v-if="Math.ceil(turnPage.totalCount/turnPage.pageSize)>1" @click="pageFn('prev')" class="glyphicon glyphicon-menu-left"></span>
            <span @click="pageFn(1)" v-if="turnPage.pageNo-3>=1">1</span>
            <em v-if="turnPage.pageNo-3>1">……</em>
            <template v-for="one in Math.ceil(turnPage.totalCount/turnPage.pageSize)">
                <span v-if="filterPage($index)" :class="$index+1==turnPage.pageNo?'active':''" @click="pageFn($index+1)" data-index="{{$index+1}}">{{$index+1}}</span>
            </template>
            <em v-if="turnPage.pageNo+3<Math.ceil(turnPage.totalCount/turnPage.pageSize)&&turnPage.pageNo+3+1!=Math.ceil(turnPage.totalCount/turnPage.pageSize)">……</em>
            <span @click="pageFn(Math.ceil(turnPage.totalCount/turnPage.pageSize))" v-if="turnPage.pageNo+3<Math.ceil(turnPage.totalCount/turnPage.pageSize)">{{Math.ceil(turnPage.totalCount/turnPage.pageSize)}}</span>
            <span v-if="Math.ceil(turnPage.totalCount/turnPage.pageSize)>1" @click="pageFn('next')" class="glyphicon glyphicon-menu-right"></span>
        </div>
    </div>
</template>
<script>
	import pagecss from '../components/page.css'
    export default {
        props: {
            turnPage: Object
        },
        data: ()=>({}),
        methods: {
            //翻页
            pageFn: function(index){
                let pageNo = this.turnPage.pageNo;
                let pageCount = Math.ceil(this.turnPage.totalCount/this.turnPage.pageSize);
                switch (index){
                    case 'prev':
                        pageNo--;
                        break;
                    case 'next':
                        pageNo++;
                        break;
                    default :
                        pageNo = index;
                }
                if(pageNo<1){
                    pageNo = 1;
                }else if(pageNo>pageCount){
                    pageNo = pageCount;
                }
                this.$set('turnPage.pageNo', pageNo);
                this.dispatchParent();
            },
            //子组件派发消息给父组件
            dispatchParent: function(){
                this.$dispatch('child-turn-page', this.turnPage);
            },
            //过滤翻页
            filterPage (index){
                return (this.turnPage.pageNo-3<=index && index<this.turnPage.pageNo+3)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// page.vue?9e9c872e